import * as React from 'react'

interface Props {
  workflowId: string
}

/*
  Programmatically opens the Solvvy Chatbot to prevent a page refresh,
  but it is unknown if this is a supported API or just me hijacking
  their internal tooling. - GS
*/
const SolvvyButton: React.FC<Props> = ({children, workflowId, ...rest}) => (
  <button onClick={() => window.Solvvy?.open({workflowId})} {...rest}>
    {children}
  </button>
)

export * from './enum'
export default SolvvyButton
